import AdminsService from 'services/admins.service';

const STORAGE_KEY = 'authUser';

const persistUser = user => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
  } catch (err) {
    // Ignore storage failures (likely private mode or quota)
  }
};

const clearPersistedUser = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    // Ignore storage failures (likely private mode or quota)
  }
};

export const login = (username, password) => async dispatch => {
  dispatch({ type: 'LOGIN_REQUEST' });

  try {
    const response = await AdminsService.login(username, password);
    
    if (response.success) {
      const user = {
        username: response.user.username,
        token: response.token
      };

      persistUser(user);

      dispatch({
        type: 'LOGIN_SUCCESS',
        payload: { user }
      });
    } else {
      // Handle case where response is successful but login failed
      dispatch({
        type: 'LOGIN_FAILURE',
        error: 'התחברות נכשלה',
        field: 'username'
      });
    }
  } catch (error) {
    dispatch({
      type: 'LOGIN_FAILURE',
      error: error.error || 'שגיאה בהתחברות',
      field: error.field || 'username'
    });
  }
};

export const logout = () => dispatch => {
  // Fire logout request in background without waiting
  AdminsService.logout().catch(() => {});
  
  clearPersistedUser();

  dispatch({
    type: 'LOGOUT'
  });
};

// The server already ended this admin's sessions (e.g. after changing their own password): forget the token without
// calling logout, which would only answer 401.
export const endSessionLocally = () => dispatch => {
  clearPersistedUser();
  dispatch({
    type: 'LOGOUT'
  });
};

export const loadPersistedUser = () => dispatch => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return;
    }

    const serialized = window.localStorage.getItem(STORAGE_KEY);
    
    if (!serialized) {
      return;
    }

    const parsed = JSON.parse(serialized);
    if (!parsed) {
      return;
    }

    // We verify both user details and token existence
    const normalizedUser = (parsed.username && parsed.token)
      ? parsed
      : null;

    if (normalizedUser) {
      dispatch({
        type: 'LOGIN_SUCCESS',
        payload: {
          user: normalizedUser
        }
      });

      // Validate session with backend
      AdminsService.checkSession().then(isValid => {
        if (!isValid) {
          dispatch(logout());
        }
      });
    }
  } catch (err) {
    // Ignore malformed storage content
    clearPersistedUser();
  }
};
